import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_upgrade_plan",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header bg-primary justify-content-end border-0 pb-0" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-sm btn-icon btn-active-color-primary",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body pt-0 pb-15 px-5 px-xl-20" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mb-13 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Upgrade a Plan"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-5" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "link-primary fw-bolder"
    }, "Pricing Guidelines"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = {
  class: "nav-group nav-group-outline mx-auto",
  "data-kt-buttons": "true"
}
const _hoisted_9 = { class: "row mt-10" }
const _hoisted_10 = { class: "col-lg-6 mb-10 mb-lg-0" }
const _hoisted_11 = { class: "nav flex-column" }
const _hoisted_12 = ["onClick", "data-bs-target"]
const _hoisted_13 = { class: "d-flex align-items-center me-2" }
const _hoisted_14 = { class: "form-check form-check-custom form-check-solid form-check-success me-6" }
const _hoisted_15 = ["value", "checked"]
const _hoisted_16 = { class: "flex-grow-1" }
const _hoisted_17 = { class: "d-flex align-items-center fs-2 fw-bolder flex-wrap" }
const _hoisted_18 = {
  key: 0,
  class: "badge badge-light-success ms-2 fs-7"
}
const _hoisted_19 = { class: "fw-bold opacity-50" }
const _hoisted_20 = { class: "ms-5" }
const _hoisted_21 = {
  key: 0,
  class: "btn btn-sm btn-primary"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "$", -1)
const _hoisted_23 = { class: "fs-3x fw-bolder" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7 opacity-50" }, [
  /*#__PURE__*/_createTextVNode("/ "),
  /*#__PURE__*/_createElementVNode("span", { "data-kt-element": "period" }, "Mon")
], -1)
const _hoisted_25 = { class: "col-lg-6" }
const _hoisted_26 = { class: "tab-content rounded h-100 bg-light p-10" }
const _hoisted_27 = ["id"]
const _hoisted_28 = { class: "pb-5" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, " What’s in Startup Plan? ", -1)
const _hoisted_30 = { class: "text-gray-400 fw-bold" }
const _hoisted_31 = { class: "pt-1" }
const _hoisted_32 = { class: "fw-bold fs-5 text-gray-700 flex-grow-1" }
const _hoisted_33 = { class: "svg-icon svg-icon-1 svg-icon-success" }
const _hoisted_34 = { class: "fw-bold fs-5 text-gray-400 flex-grow-1" }
const _hoisted_35 = { class: "svg-icon svg-icon-1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-row-fluid pt-12" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "reset",
    class: "btn btn-white me-3",
    "data-bs-dismiss": "modal"
  }, " Cancel "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Upgrade Plan")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.current = 'month')),
                class: _normalizeClass([[_ctx.current === 'month' && 'active'], "btn btn-color-gray-400 btn-active btn-active-secondary px-6 py-3 me-2"])
              }, " Monthly ", 2),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.current = 'annual')),
                class: _normalizeClass([[_ctx.current === 'annual' && 'active'], "btn btn-color-gray-400 btn-active btn-active-secondary px-6 py-3"])
              }, " Annual ", 2)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plans, (plan, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      onClick: ($event: any) => (_ctx.selected = plan.title),
                      class: _normalizeClass(["nav-link btn btn-outline btn-outline-dashed btn-color-dark d-flex flex-stack text-start p-6", [
                        index !== _ctx.plans.length - 1 && 'mb-6',
                        plan.default && 'active',
                        !plan.custom && 'btn-active btn-active-primary',
                      ]]),
                      "data-bs-toggle": "tab",
                      "data-bs-target": `#kt_upgrade_plan_${index}`
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "plan",
                            value: plan.title,
                            checked: _ctx.selected === plan.title
                          }, null, 8, _hoisted_15)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("h2", _hoisted_17, [
                            _createTextVNode(_toDisplayString(plan.title) + " ", 1),
                            (plan.label)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(plan.label), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(plan.subTitle), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        (plan.custom)
                          ? (_openBlock(), _createElementBlock("button", _hoisted_21, " Contact Us "))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_22,
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.current === "month"
                                ? plan.priceMonth
                                : plan.priceAnnual), 1),
                              _hoisted_24
                            ], 64))
                      ])
                    ], 10, _hoisted_12))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plans, (plan, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (!plan.custom)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass([[plan.default && 'show active'], "tab-pane fade"]),
                            id: `kt_upgrade_plan_${index}`
                          }, [
                            _createElementVNode("div", _hoisted_28, [
                              _hoisted_29,
                              _createElementVNode("div", _hoisted_30, _toDisplayString(plan.description), 1)
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.features, (feature, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: i,
                                  class: _normalizeClass([[i !== plan.features - 1 && 'mb-7'], "d-flex align-items-center"])
                                }, [
                                  (feature.supported)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("span", _hoisted_32, _toDisplayString(feature.title), 1),
                                        _createElementVNode("span", _hoisted_33, [
                                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen043.svg" })
                                        ])
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("span", _hoisted_34, _toDisplayString(feature.title), 1),
                                        _createElementVNode("span", _hoisted_35, [
                                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen040.svg" })
                                        ])
                                      ], 64))
                                ], 2))
                              }), 128))
                            ])
                          ], 10, _hoisted_27))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ])
            ])
          ]),
          _hoisted_36
        ])
      ])
    ])
  ]))
}